export default __webpack_public_path__ + "static/media/meta.484a0d89.webp";